import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {Box, Stack, Tooltip} from "@mui/material";
import type {SurveyQuestion} from "crqlar-react-common/dist/models/survey/surveyQuestion.model";
import type {SurveyAnswer} from "crqlar-react-common/dist/models/survey/surveySubmission.model";
import {useLocalize} from "crqlar-react-common/dist/utils/text.util";
import {SurveyAnswerContext, surveyAnswerParts} from "./surveyAnswer.util";

export const SURVEY_SENSITIVE_MASK = '********';

export const isWithheldSensitiveAnswer = (
    answer: SurveyAnswer | undefined,
    question: SurveyQuestion | undefined,
    ctx: SurveyAnswerContext
): boolean => {
    if (!answer || question?.isSensitive !== true) return false;

    const {parts, mediaCount, hasSignature} = surveyAnswerParts(answer, question, ctx);
    return !parts.length && !mediaCount && !hasSignature;
};

interface SurveySensitiveAnswerValueProps {
    asPrint?: boolean
    tooltip?: string
}

export function SurveySensitiveAnswerValue({asPrint = false, tooltip}: SurveySensitiveAnswerValueProps) {
    const {t} = useLocalize();

    if (asPrint) return <>{SURVEY_SENSITIVE_MASK}</>;

    return (
        <Tooltip title={tooltip ?? t('Sensitive answers are withheld. Open the submission to reveal them.')}>
            <Stack direction={'row'} alignItems={'center'} gap={0.75} sx={{minWidth: 0}}>
                <LockOutlinedIcon sx={{fontSize: 15, color: 'warning.main', flexShrink: 0}}/>

                <Box component={'span'} sx={{color: 'text.secondary', letterSpacing: 1, userSelect: 'none'}}>
                    {SURVEY_SENSITIVE_MASK}
                </Box>
            </Stack>
        </Tooltip>
    );
}
